import { DdpImage } from "@/components/shared/DdpImage"
import { LinkWrapper } from "@/components/shared/LinkWrapper"
import { TDdpMedia } from "@/shared/types"

export function FifthSection(props: Array<{
    title: string
    imageCard: Array<{
        caption: string
        heading: string
        imageCard: Array<TDdpMedia>
        cocktailID: string
    }>
}>) {
    const { title, imageCard } = props[0]
    return (
        <div className="landing-fifth-section">
            <div className="title">{title}</div>
            <div className="card-wrapper">
                {
                    imageCard.map(item => (
                        <LinkWrapper url={`/dreamcocktaildetail?cocktailId=${item.cocktailID}`} key={item.cocktailID}>
                            <div className="image-card">
                                <div className="top-media-wrapper">
                                    <DdpImage image={item.imageCard[0]} />
                                </div>

                                <div className="heading">{item.heading}</div>
                                <div className="caption">{item.caption}</div>
                            </div>
                        </LinkWrapper>
                    ))
                }
            </div>
        </div>
    );
}